import { Box, type BoxProps } from '@chakra-ui/react'

import { getPublicUrl } from '@/client/services/url'

interface NoiseTextureOverlayProps extends BoxProps {
  opacity?: number
  bgSize?: string
}

export default function NoiseTextureOverlay({
  opacity = 0.1,
  bgSize = '100px 100px',
  ...props
}: NoiseTextureOverlayProps) {
  return (
    <Box
      position="absolute"
      inset={0}
      bgImage={getPublicUrl('/backgrounds/noise-texture-2.png')}
      bgRepeat="repeat"
      bgSize={bgSize}
      opacity={opacity}
      mixBlendMode="multiply"
      pointerEvents="none"
      {...props}
    />
  )
}
